module.exports = __webpack_public_path__ + "static/img/wayfinder-change.75c26806.png";